import { fontFamily } from 'common/styles/theme/typography/fontFamily';
import { fontSize } from 'common/styles/theme/typography/fontSize';

export const typography = {
    fontFamily,
    fontSize,
};
